// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2mCUh","dragIcon":"Choice_dragIcon__2FQ8F","left":"Choice_left__1LkwG","input":"Choice_input__2zbgc"};